import React, { useState } from 'react';
import Map from '../features/contactUs/components/googleMap';
import ContactUsHeader from '../assets/images/contactUsHeader.png';
import WhatsAppLink from '../features/contactUs/components/WhatsAppLink';
import ContactUsForm from '../features/contactUs/components/ContactUsForm';
import { useTranslation } from 'react-i18next';

export default function ContactUs() {
    const [errorMessage, setErrorMessage] = useState('');
    const [dataUpdate, setDataUpdate] = useState(false);
    const { t, i18n } = useTranslation();

    return (
        <div>
            <div className='text-center bg-light-gray my-4 py-3'>
                <img
                    src={ContactUsHeader}
                    alt='contact us header information'
                    className='contact-us-header'
                />
            </div>
            <div className='text-start'>
                <div className='container d-flex flex-column flex-md-row align-items-center justify-content-between'>
                    <h4 className='c-darkOrange'>{t("Contact Us")}</h4>
                    <WhatsAppLink />
                </div>
                <ContactUsForm
                    setErrorMessage={setErrorMessage}
                    setDataUpdate={setDataUpdate}
                />
                {errorMessage &&
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {errorMessage}
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>}
                {dataUpdate &&
                    <>
                        {i18n.language === 'ar' ? (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                تم ارسال رسالتكم بنجاح .. شكرا لك
                                سنتواصل معكم في اقرب وقت
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        ) : (
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                Your message has been sent successfully .. Thank you
                                We will contact you as soon as possible
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        )}</>
                }
                <Map />
            </div>
        </div>
    );
};